var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.042 10.292c0 1.196-.971 2.166-2.167 2.166-1.196 0-2.167-.97-2.167-2.166s.971-2.167 2.167-2.167c1.196 0 2.167.97 2.167 2.167zM22.208 10.292L25.458 10.292M22.208 10.292c0 1.196-.97 2.166-2.166 2.166s-2.167-.97-2.167-2.166.97-2.167 2.167-2.167c1.196 0 2.166.97 2.166 2.167zM7.042 10.292L17.875 10.292",
    transform: "translate(-60 -796) translate(20 767) translate(27 16) translate(13 13) translate(0 6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 10.292V6.5c0-.898-.728-1.625-1.625-1.625h-1.625L18.958.542H8.667L6.5 4.875H2.167c-.898 0-1.625.727-1.625 1.625v3.792h2.166",
    transform: "translate(-60 -796) translate(20 767) translate(27 16) translate(13 13) translate(0 6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.208 4.875L10.292 2.708 11.375 2.708",
    transform: "translate(-60 -796) translate(20 767) translate(27 16) translate(13 13) translate(0 6.5)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.a1cf68c3.svg";
export { ForwardRef as ReactComponent };